export const QA_NAME_SEARCH_RESULTS_EMAILS_TABLE = 'searchResultsEmailsTable'

export const SEARCH_RESULTS_EMAILS_CONFIG_API =
  'idwell-api/api/v3/table/tables/email-messages-search/'
